import React from "react";

import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";

import FormValidator from "validatorjs";

import NewsletterService from "../../services/NewsletterService";
import CookieService from "../../services/CookieService";
import AnalyticsService from "../../services/AnalyticsService";

import DownloadTextInput from "./DownloadTextInput";
import DownloadCheckbox from "./DownloadCheckbox";

const DownloadForm = ({
  url,
  placeholders,
  waitText,
  requiredText,
  buttonText,
  thankYouMessage,
  termsMessage,
  source,
}) => {
  const langcode = CookieService.get("DNSBELGIUM_LANGUAGE");
  FormValidator.useLang(langcode);

  const handleValidation = (values) => {
    const rules = {
      "first-name": "required",
      "last-name": "required",
      email: "email|required",
      terms: "accepted",
    };

    let errorMessages = {
      required: "Vul dit veld in.",
      email: "Vul een geldig e-mailadres in.",
      "accepted.terms": "Accepteer ons privacybeleid.",
    };

    if (langcode === "fr") {
      errorMessages = {
        required: "Veuillez remplir ce champs.",
        email: "Veuillez indiquer une adresse e-mail valide.",
        "accepted.terms":
          "Veuillez accepter notre politique des données à caractère personnel.",
      };
    }

    if (langcode === "en") {
      errorMessages = {
        required: "Please fill in this field.",
        email: "Please provide a valid e-mail address.",
        "accepted.terms": "Please agree to our privacy policy.",
      };
    }

    const validator = new FormValidator(values, rules, errorMessages);
    validator.check();

    return validator.errors.all();
  };

  const handleDownload = () => {
    window.open(url);
  };

  const handleSubmit = async (values) => {
    values.type = "download";

    const response = await NewsletterService.subscribe(values);
    const data = await response.json();

    if (!response.ok && values.terms) {
      return {
        [FORM_ERROR]: data.message,
      };
    }

    handleDownload();

    let category = "Download";
    const action = "Subscribe download";

    AnalyticsService.track(category, action, source);

    return {};
  };

  const renderThankYouMessage = () => {
    return (
      <div className="optin__thank-you">
        <span className="optin__icon">
          <svg
            className="icon-small"
            viewBox="0 0 18 16"
            role="presentation"
            focusable="false"
          >
            <use xlinkHref="#icon-check" />
          </svg>
        </span>
        <p dangerouslySetInnerHTML={{ __html: thankYouMessage }} />
      </div>
    );
  };

  const renderForm = ({
    handleSubmit,
    submitting,
    submitSucceeded,
    submitError,
  }) => {
    return (
      <form className="optin__form" onSubmit={handleSubmit} noValidate>
        <div className={`optin__input-group is-multi-field`}>
          {!submitSucceeded && (
            <React.Fragment>
              <div className="optin__columns">
                <label
                  className="optin__input-wrapper optin-required"
                  htmlFor="first-name"
                >
                  <span className="visually-hidden">
                    {placeholders["first-name"]}
                  </span>
                  <Field
                    component={DownloadTextInput}
                    id="first-name"
                    name="first-name"
                    type="text"
                    placeholder={placeholders["first-name"]}
                  />
                </label>
                <label
                  className="optin__input-wrapper optin-required"
                  htmlFor="last-name"
                >
                  <span className="visually-hidden">
                    {placeholders["last-name"]}
                  </span>
                  <Field
                    component={DownloadTextInput}
                    id="last-name"
                    name="last-name"
                    type="text"
                    placeholder={placeholders["last-name"]}
                  />
                </label>
              </div>
              <label
                className="optin__input-wrapper optin-required"
                htmlFor="email"
              >
                <span className="visually-hidden">{placeholders.email}</span>
                <Field
                  component={DownloadTextInput}
                  id="email"
                  name="email"
                  type="email"
                  placeholder={placeholders.email}
                />
              </label>
              <div className="optin-checkbox">
                <label className="option optin-required" htmlFor="terms">
                  <Field
                    component={DownloadCheckbox}
                    id="terms"
                    type="checkbox"
                    text={termsMessage}
                    name="terms"
                  />
                </label>
              </div>
              <div className="optin__required-text">(*) {requiredText}</div>
              <button className="optin__button button is-large" type="submit">
                {submitting ? waitText : buttonText}
              </button>
            </React.Fragment>
          )}
          {submitSucceeded && renderThankYouMessage()}
        </div>

        {submitError && <div className="optin__error">{submitError}</div>}
      </form>
    );
  };

  return (
    <Form
      validate={handleValidation}
      onSubmit={handleSubmit}
      render={renderForm}
    />
  );
};

export default DownloadForm;
